import React, { FC } from 'react';
import EventCharts, { EventCharts as EventChartsInnerComponent } from '@components/machines/components/eventsChart';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { usePartDetails } from '@v2/pages/common/hooks/usePartDetails';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { connect } from 'react-redux';
import { getNCFileByPartId } from '@reducers/manufacture';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { getProductionBatchByPart, operationsSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { getPartByID } from '@reducers/parts';

interface PartDetailsNCFilePerformanceActiveProps {}

const PartDetailsNCFilePerformanceActiveComponent: FC<PartDetailsNCFilePerformanceActiveProps> = ({
  getNCFileByPartId,
  clearTools,
  getTools,
  getProductionBatchByPart,
  updateHeaderConfig,
  getPartByID,
  operationsSearch,
}) => {
  const title = useTitle();

  usePartDetails({
    clearTools,
    getNCFileByPartId,
    getTools,
    getProductionBatchByPart,
    updateHeaderConfig,
    getPartByID,
    operationsSearch,
    getAllNcFiles: true,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <EventCharts getContentElement={(props) => <EventChartsInnerComponent {...props} />} />
    </DetailsPageWrapper>
  );
};

const PartDetailsNCFilePerformanceActive = connect(null, {
  getNCFileByPartId,
  clearTools,
  getTools,
  getProductionBatchByPart,
  updateHeaderConfig,
  getPartByID,
  operationsSearch,
})(PartDetailsNCFilePerformanceActiveComponent);

export { PartDetailsNCFilePerformanceActive };
